import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { ExportComponent } from './export.component';

@NgModule({
	declarations: [ExportComponent],
	imports: [
		MatSelectModule,
		MatExpansionModule,
		MatIconModule,
		MatInputModule,
		FormsModule,
		CommonModule,
		MatButtonModule,
		MatTableModule,
		MatCheckboxModule,
		MatProgressBarModule,
		MatStepperModule,
		MatFormFieldModule,
		RouterModule.forChild([{ path: '**', data: SaveStateData, component: ExportComponent }])
	]
})
export class ExportModule {}
